var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextBold = function SvgTextBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6C89",
    d: "M11.406 15.625H5.625V4.375h5.313a3.281 3.281 0 0 1 2.5 5.406 3.281 3.281 0 0 1-2.032 5.844M7.5 13.75h3.894a1.408 1.408 0 0 0 .994-2.4 1.4 1.4 0 0 0-.994-.412H7.5zm0-4.687h3.438a1.406 1.406 0 1 0 0-2.813H7.5z"
  })));
};
export default SvgTextBold;